import { adapterListResponse } from "./adapters/adapterList";
import axios from "axios";

export const getDeletedRecordsDb = async () => {
  try {
    let deletedRecords: any = await axios({
      method: "get",
      url: "/api/deleted-records",
    })
      .then((response) => {
        let adaptedResponse = adapterListResponse(response.data);
        return adaptedResponse;
      })
      .catch((error) => {
        return false;
      });

    return deletedRecords;
  } catch (error) {
    return false;
  }
};
